import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ActivityLogChild from "./ActivityLogChild";

const ActivityLog = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ActivityLogChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ActivityLog;
